export default __webpack_public_path__ + "static/media/kafkaTable.ed83abb7.png";